import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { getAllCards, saveCard, removeCard } from 'actions/stripe';
import CardDetail from 'pages/account-settings/CardDialog';
import Button from 'components/Button';
import CryptoJS from 'crypto-js';
import DeleteIcon from '@material-ui/icons/Delete';
import CardImage from 'assets/images/cardImage.png';
import {
  CardsWrapper,
  AddCardButtonWrapper,
  CardContainer,
  CardWrapper,
  SuccessIcon,
  DeleteCard,
} from 'styles/pages/account-setting/passwordForm';

const Cards = () => {
  const dispatch = useDispatch();
  const emailId = useSelector((state) => state?.auth?.profile?.emailid);
  const [cards, setCards] = useState(null);
  const [addCard, setAddCard] = useState(null);

  const fetchCards = async () => {
    const cards = await dispatch(
      getAllCards({
        user: emailId,
      })
    );
    setCards(cards);
  };

  useEffect(() => {
    if (!cards) fetchCards();
  }, [cards]);

  return (
    <CardsWrapper>
      {!cards?.length && <h3 className="error">No Card Found</h3>}

      {cards?.map &&
        cards.map((card, index) => {
          const regex = /\b(?:\d{4}[ -]?){3}(?=\d{4}\b)/gm;
          const mask = `**** **** **** `;
          const cardNo = CryptoJS.AES.decrypt(card.cardNumber, 'bot').toString(
            CryptoJS.enc.Utf8
          );

          return (
            <CardContainer key={`card${index}`}>
              <CardWrapper selected={index === 0}>
                {index === 0 && <SuccessIcon />}
                <img src={CardImage} alt="CardImage" />
                <h3>{cardNo.replace(regex, mask)}</h3>
              </CardWrapper>
              <DeleteCard>
                <DeleteIcon
                  onClick={async () => {
                    await dispatch(
                      removeCard({
                        user: emailId,
                        cardNumber: card?.cardNumber,
                      })
                    );

                    setCards(undefined);
                  }}
                />
              </DeleteCard>
            </CardContainer>
          );
        })}

      <AddCardButtonWrapper>
        <Button title="Add Card" onClick={() => setAddCard(true)} />
      </AddCardButtonWrapper>

      {addCard && (
        <CardDetail
          open={addCard}
          hide={() => setAddCard(false)}
          saveCard={async (card) => {
            const cardDetails = {
              cardNumber: CryptoJS.AES.encrypt(
                card.cardNumber,
                'bot'
              ).toString(),
              cardExpMonth: CryptoJS.AES.encrypt(
                card.cardExpMonth,
                'bot'
              ).toString(),
              cardExpYear: CryptoJS.AES.encrypt(
                card.cardExpYear,
                'bot'
              ).toString(),
              cvv: CryptoJS.AES.encrypt(card.cvv, 'bot').toString(),
            };

            await dispatch(saveCard({ cardDetails, user: emailId }));
            setCards(null);
          }}
        />
      )}
    </CardsWrapper>
  );
};

export default Cards;
